var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      _c(
        "Modal",
        {
          attrs: {
            title: "预售 - 转运站发货",
            width: 1200,
            "footer-hide": true,
          },
          on: { "on-visible-change": _vm.onShowChange },
          model: {
            value: _vm.show,
            callback: function ($$v) {
              _vm.show = $$v
            },
            expression: "show",
          },
        },
        [
          _vm.innerSpin
            ? _c("Spin", { attrs: { size: "large", fix: "" } })
            : _vm._e(),
          _c(
            "Card",
            { attrs: { padding: 0, bordered: false, "dis-hover": true } },
            [
              _c(
                "Row",
                { attrs: { gutter: 16 } },
                [
                  _c(
                    "Col",
                    { attrs: { span: "24" } },
                    [
                      _c(
                        "Form",
                        {
                          ref: "deliveryForm",
                          attrs: { "label-position": "top" },
                        },
                        [
                          _c(
                            "Row",
                            { attrs: { gutter: 16 } },
                            [
                              _c(
                                "Col",
                                { attrs: { span: "4" } },
                                [
                                  _c(
                                    "FormItem",
                                    { attrs: { label: "定单编号" } },
                                    [
                                      _c("Input", {
                                        attrs: {
                                          value:
                                            _vm.orderRecord
                                              .preSaleOrderRecordCode,
                                          readonly: "",
                                        },
                                      }),
                                    ],
                                    1
                                  ),
                                ],
                                1
                              ),
                              _c(
                                "Col",
                                { attrs: { span: "4" } },
                                [
                                  _c(
                                    "FormItem",
                                    { attrs: { label: "会员名称" } },
                                    [
                                      _c("Input", {
                                        attrs: {
                                          value:
                                            _vm.orderRecord
                                              .deliveryAddressContacts,
                                          readonly: "",
                                        },
                                      }),
                                    ],
                                    1
                                  ),
                                ],
                                1
                              ),
                              _c(
                                "Col",
                                { attrs: { span: "4" } },
                                [
                                  _c(
                                    "FormItem",
                                    { attrs: { label: "会员电话" } },
                                    [
                                      _c("Input", {
                                        attrs: {
                                          value:
                                            _vm.orderRecord
                                              .deliveryAddressPhone,
                                          readonly: "",
                                        },
                                      }),
                                    ],
                                    1
                                  ),
                                ],
                                1
                              ),
                              _c(
                                "Col",
                                { attrs: { span: "4" } },
                                [
                                  _c(
                                    "FormItem",
                                    { attrs: { label: "会员账户余额" } },
                                    [
                                      _c("Input", {
                                        attrs: {
                                          value:
                                            _vm.memberFundInfo
                                              .memberFundBalance,
                                          readonly: "",
                                        },
                                      }),
                                    ],
                                    1
                                  ),
                                ],
                                1
                              ),
                              _c(
                                "Col",
                                { attrs: { span: "4" } },
                                [
                                  _c(
                                    "FormItem",
                                    { attrs: { label: "会员定金余额" } },
                                    [
                                      _c("Input", {
                                        attrs: {
                                          value:
                                            _vm.memberFundInfo
                                              .memberDepositBablance,
                                          readonly: "",
                                        },
                                      }),
                                    ],
                                    1
                                  ),
                                ],
                                1
                              ),
                              _c(
                                "Col",
                                { attrs: { span: "4" } },
                                [
                                  _c(
                                    "FormItem",
                                    { attrs: { label: "定单日期" } },
                                    [
                                      _c("Input", {
                                        attrs: {
                                          value: _vm.formatDateTimeString(
                                            _vm.orderRecord
                                              .preSaleOrderRecordCreateAt
                                          ),
                                          readonly: "",
                                        },
                                      }),
                                    ],
                                    1
                                  ),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                          _c(
                            "Row",
                            { attrs: { gutter: 16 } },
                            [
                              _c(
                                "Col",
                                { attrs: { span: "4" } },
                                [
                                  _c(
                                    "FormItem",
                                    { attrs: { label: "收货区域" } },
                                    [
                                      _c("Input", {
                                        attrs: {
                                          value: _vm.orderRecord.dist,
                                          readonly: "",
                                        },
                                      }),
                                    ],
                                    1
                                  ),
                                ],
                                1
                              ),
                              _c(
                                "Col",
                                { attrs: { span: "4" } },
                                [
                                  _c(
                                    "FormItem",
                                    { attrs: { label: "物流配置" } },
                                    [
                                      _c("Input", {
                                        attrs: {
                                          value:
                                            _vm.logisticsInfo.logisticsDistName,
                                          readonly: "",
                                        },
                                      }),
                                    ],
                                    1
                                  ),
                                ],
                                1
                              ),
                              _c(
                                "Col",
                                { attrs: { span: "4" } },
                                [
                                  _c(
                                    "FormItem",
                                    { attrs: { label: "物流公司" } },
                                    [
                                      _c("Input", {
                                        attrs: {
                                          value:
                                            _vm.logisticsInfo
                                              .logisticsCompanyName,
                                          readonly: "",
                                        },
                                      }),
                                    ],
                                    1
                                  ),
                                ],
                                1
                              ),
                              _c(
                                "Col",
                                { attrs: { span: "4" } },
                                [
                                  _c(
                                    "FormItem",
                                    { attrs: { label: "物流单价" } },
                                    [
                                      _c("Input", {
                                        attrs: {
                                          value:
                                            _vm.logisticsInfo
                                              .logisticsCompanyPrice,
                                          readonly: "",
                                        },
                                      }),
                                    ],
                                    1
                                  ),
                                ],
                                1
                              ),
                              _c(
                                "Col",
                                { attrs: { span: "4" } },
                                [
                                  _c(
                                    "FormItem",
                                    { attrs: { label: "物流费用" } },
                                    [
                                      _c(
                                        "div",
                                        {
                                          attrs: { slot: "label" },
                                          slot: "label",
                                        },
                                        [
                                          _c("span", [_vm._v("物流费用")]),
                                          _vm.orderRecord
                                            .preSaleOrderRecordIsPaidDeliveryFee ===
                                          1
                                            ? _c(
                                                "a",
                                                {
                                                  staticStyle: {
                                                    "margin-left": "10px",
                                                    color: "red",
                                                  },
                                                  attrs: { href: "#" },
                                                  on: {
                                                    click: function ($event) {
                                                      _vm.deliveryFeeHistoryModal.show = true
                                                    },
                                                  },
                                                },
                                                [_vm._v("查看运费")]
                                              )
                                            : _vm._e(),
                                        ]
                                      ),
                                      _c("Input-number", {
                                        staticStyle: { width: "100%" },
                                        model: {
                                          value:
                                            _vm.orderRecord
                                              .preSaleOrderRecordStationDeliveryFee,
                                          callback: function ($$v) {
                                            _vm.$set(
                                              _vm.orderRecord,
                                              "preSaleOrderRecordStationDeliveryFee",
                                              $$v
                                            )
                                          },
                                          expression:
                                            "orderRecord.preSaleOrderRecordStationDeliveryFee",
                                        },
                                      }),
                                    ],
                                    1
                                  ),
                                ],
                                1
                              ),
                              _c(
                                "Col",
                                { attrs: { span: "4" } },
                                [
                                  _c(
                                    "FormItem",
                                    { attrs: { label: " " } },
                                    [
                                      _c(
                                        "Button",
                                        {
                                          attrs: { type: "primary" },
                                          on: { click: _vm.OnPayDeliveryFee },
                                        },
                                        [_vm._v("收取物流费")]
                                      ),
                                    ],
                                    1
                                  ),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                          _c(
                            "Row",
                            { attrs: { gutter: 16 } },
                            [
                              _c(
                                "Col",
                                { attrs: { span: "24" } },
                                [
                                  _c("Table", {
                                    ref: "productTable",
                                    attrs: {
                                      size: "small",
                                      columns: _vm.productTable.columns,
                                      data: _vm.orderDetails,
                                      "highlight-row": "",
                                      stripe: "",
                                      border: "",
                                    },
                                  }),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                          _vm.orderRecord
                            .preSaleOrderRecordIsPaidDeliveryFee === 1
                            ? _c(
                                "Row",
                                {
                                  staticClass: "row-margin-top-15",
                                  staticStyle: { "margin-top": "10px" },
                                  attrs: {
                                    gutter: 16,
                                    type: "flex",
                                    justify: "space-between",
                                  },
                                },
                                [
                                  _c(
                                    "Col",
                                    { attrs: { span: "10" } },
                                    [
                                      _c("DatePicker", {
                                        attrs: {
                                          value: _vm.form.deliveryDate,
                                          type: "date",
                                          format: "yyyy-MM-dd",
                                          placeholder: "请填写发货日期",
                                        },
                                        on: {
                                          "on-change": _vm.onDeliveryDateChange,
                                        },
                                      }),
                                      _c(
                                        "Checkbox",
                                        {
                                          staticStyle: {
                                            "margin-left": "10px",
                                          },
                                          model: {
                                            value: _vm.needPayBackDeposit,
                                            callback: function ($$v) {
                                              _vm.needPayBackDeposit = $$v
                                            },
                                            expression: "needPayBackDeposit",
                                          },
                                        },
                                        [_vm._v("返还定金")]
                                      ),
                                      _c(
                                        "Button",
                                        {
                                          attrs: { type: "primary" },
                                          on: { click: _vm.onSubmit },
                                        },
                                        [_vm._v("发货")]
                                      ),
                                      _c(
                                        "Button",
                                        {
                                          staticStyle: { "margin-left": "5px" },
                                          attrs: { type: "success" },
                                          on: {
                                            click: function ($event) {
                                              return _vm.printDeliveryRecord()
                                            },
                                          },
                                        },
                                        [_vm._v("打印送货单")]
                                      ),
                                    ],
                                    1
                                  ),
                                  _c("Col", { attrs: { span: "10" } }, [
                                    _c(
                                      "div",
                                      {
                                        staticStyle: { "text-align": "right" },
                                      },
                                      [
                                        _c("span", [
                                          _vm._v(
                                            "苗场发货量:" +
                                              _vm._s(
                                                _vm.productTable
                                                  .totalSeedfarmQuantity
                                              )
                                          ),
                                        ]),
                                        _c(
                                          "span",
                                          {
                                            staticStyle: {
                                              "margin-left": "20px",
                                            },
                                          },
                                          [
                                            _vm._v(
                                              "转运站发货量:" +
                                                _vm._s(
                                                  _vm.productTable.totalQuantity
                                                )
                                            ),
                                          ]
                                        ),
                                        _c(
                                          "span",
                                          {
                                            staticStyle: {
                                              "margin-left": "20px",
                                            },
                                          },
                                          [
                                            _vm._v(
                                              "转运站发货金额:" +
                                                _vm._s(
                                                  _vm.numberToFixed(
                                                    _vm.productTable.totalValue,
                                                    2
                                                  )
                                                )
                                            ),
                                          ]
                                        ),
                                      ]
                                    ),
                                  ]),
                                ],
                                1
                              )
                            : _vm._e(),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c(
                "Row",
                {
                  staticClass: "row-margin-top-15",
                  staticStyle: { "margin-top": "10px" },
                  attrs: { gutter: 16 },
                },
                [
                  _c(
                    "Col",
                    { attrs: { spal: "24" } },
                    [
                      _c(
                        "Collapse",
                        { attrs: { value: [] } },
                        [
                          _c("Panel", { attrs: { name: "preSale" } }, [
                            _vm._v(
                              "\n                        历史发货单\n                        "
                            ),
                            _c(
                              "div",
                              { attrs: { slot: "content" }, slot: "content" },
                              [
                                _c("Table", {
                                  ref: "deliveryHistoryTable",
                                  attrs: {
                                    size: "small",
                                    columns: _vm.deliveryHistoryTable.columns,
                                    data: _vm.deliveryDetails,
                                    stripe: "",
                                    border: "",
                                  },
                                }),
                              ],
                              1
                            ),
                          ]),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "Modal",
        {
          attrs: { title: "该单运费收取记录" },
          model: {
            value: _vm.deliveryFeeHistoryModal.show,
            callback: function ($$v) {
              _vm.$set(_vm.deliveryFeeHistoryModal, "show", $$v)
            },
            expression: "deliveryFeeHistoryModal.show",
          },
        },
        [
          _c(
            "List",
            { attrs: { size: "small" } },
            _vm._l(
              _vm.deliveryFeeHistoryModal.deliveryFeeList,
              function (item, index) {
                return _c("ListItem", { key: index }, [
                  _vm._v(
                    _vm._s(
                      _vm.formatDateTimeString(item.memberFundRecordCreateAt)
                    ) +
                      " " +
                      _vm._s(item.memberFundRecordOperatorName) +
                      " (￥:" +
                      _vm._s(item.memberFundRecordConsume) +
                      "元)"
                  ),
                ])
              }
            ),
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }